import { ThemeSelectors } from "@at/design-system-foundation";
import styled from "styled-components";

export const OpeningTimesWrapper = styled.dl`
  color: ${({ theme }) => ThemeSelectors.getTitleColor(theme)};
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ThemeSelectors.getGroupOneSpacing(theme)};
`;

export const OpeningTimesRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const OpeningTimesDay = styled.dt`
  font-variation-settings: "wght" 400;
`;

export const OpeningTimesTime = styled.dd`
  font-variation-settings: "wght" 400;
`;
